import React, { useState } from 'react'

// images
import DownloadIcon from 'assets/icons/download-icon.svg?component'
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'

// styles
import styles from './index.module.scss'
import { getApparelType, getFirstUpperString } from 'utils/helpers'

const MerchOrderDetail = props => {
  const { type, productDetail } = props
  const [showEmbroidery, setShowEmbroidery] = useState(false)
  const [showNotice, setShowNotice] = useState(false)
  const [showShipping, setShowShipping] = useState(false)
  const [showPolicy, setShowPolicy] = useState(false)
  const [showSpecification, setShowSpecification] = useState(false)

  const getPrintAreas = () => {
    let areas = []
    productDetail.options.addons.map(item => {
      if (item.product_addon_id === 1) areas.push('Front')
      if (item.product_addon_id === 2) areas.push('Back')
      if (item.product_addon_id === 3) areas.push('Right')
      if (item.product_addon_id === 4) areas.push('Left')
    })
    return areas.join(', ')
  }

  return (
    <div>
      {/* Shipping */}
      {type === 'foster' && (
        <div>
          <div
            className="w-full flex justify-between items-center mt-[15px]"
            onClick={() => setShowShipping(!showShipping)}
          >
            <div className={styles.desc}>Shipping</div>
            <div>{showShipping ? <MinusIcon /> : <PlusIcon />}</div>
          </div>
          <div className={`mt-[15px] ${styles.divider}`} />
          {showShipping && (
            <div className={`${styles.endsTime} mt-[15px]`}>
              {
                'Shipping times can vary, but on average, domestic orders are delivered within 1–2 weeks, and international orders within 2–3 weeks.'
              }
            </div>
          )}
        </div>
      )}

      {/* Specifications */}
      {type === 'foster' && (
        <div>
          <div
            className="w-full flex justify-between items-center mt-[30px]"
            onClick={() => setShowSpecification(!showSpecification)}
          >
            <div className={styles.desc}>Specifications</div>
            <div>{showSpecification ? <MinusIcon /> : <PlusIcon />}</div>
          </div>
          <div className={`mt-[15px] ${styles.divider}`} />
          {showSpecification && (
            <div className={`${styles.endsTime} mt-[15px]`}>
              <div className="w-full flex justify-between items-center">
                <div className={styles.specLabel}>Apparel Type</div>
                <div className={styles.specValue}>{getApparelType(productDetail.product_type_id)}</div>
              </div>
              <div className="w-full flex justify-between items-center mt-[6px]">
                <div className={styles.specLabel}>Primary Print Technique</div>
                <div className={styles.specValue}>{getFirstUpperString(productDetail.options.print_technique)}</div>
              </div>
              <div className="w-full flex justify-between items-center mt-[6px]">
                <div className={styles.specLabel}>Print Areas</div>
                <div className={styles.specValue}>{getPrintAreas()}</div>
              </div>
              <div className="w-full flex justify-between items-center mt-[6px]">
                <div className={styles.specLabel}>Color</div>
                <div className={styles.specValue}>
                  {getFirstUpperString(
                    productDetail.product_type_id === 0
                      ? productDetail.options.colors.length > 0
                        ? productDetail.options.colors[0]
                        : 'white'
                      : productDetail.options.color
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Return Policy */}
      {type === 'foster' && (
        <div>
          <div
            className="w-full flex justify-between items-center mt-[30px]"
            onClick={() => setShowPolicy(!showPolicy)}
          >
            <div className={styles.desc}>Return Policy</div>
            <div>{showPolicy ? <MinusIcon /> : <PlusIcon />}</div>
          </div>
          <div className={`mt-[15px] ${styles.divider}`} />
          {showPolicy && (
            <div className={`${styles.endsTime} mt-[15px]`}>
              {
                'Due to the nature of custom merch, we’re unable to offer exchanges or refunds. Please double-check sizing, colors, and designs before placing your order. If your item arrives damaged or there’s an issue with the print, let us know within 7 days of delivery—we’ll make it right.'
              }
            </div>
          )}
        </div>
      )}

      {/* Embroidery Disclaimer */}
      {type === 'foster' && productDetail?.options?.print_technique === 'embroidery' && (
        <div>
          <div
            className="w-full flex justify-between items-center mt-[30px]"
            onClick={() => setShowEmbroidery(!showEmbroidery)}
          >
            <div className={styles.desc}>Embroidery Disclaimer</div>
            <div>{showEmbroidery ? <MinusIcon /> : <PlusIcon />}</div>
          </div>
          <div className={`mt-[15px] ${styles.divider}`} />
          {showEmbroidery && (
            <div className={`${styles.endsTime} mt-[15px]`}>
              {
                'Please note that the actual embroidered design may vary from the digital preview shown. While we strive for accuracy, the nature of embroidery can result in differences in color, texture, and placement.'
              }
            </div>
          )}
        </div>
      )}

      {/* Customs Notice */}
      <div className="w-full flex justify-between items-center mt-[30px]" onClick={() => setShowNotice(!showNotice)}>
        <div className={styles.desc}>{type === 'foster' ? 'Customs Notice' : 'Liability Disclaimer'}</div>
        <div>{showNotice ? <MinusIcon /> : <PlusIcon />}</div>
      </div>
      <div className={`mt-[15px] ${styles.divider}`} />

      {showNotice && (
        <div className={`${styles.endsTime} mt-[15px]`}>
          {type === 'foster'
            ? 'All customers outside of the United States are responsible for the customs fees/duties that may be charged by their country for import. This amount may vary depending on your country. We advise looking up your country’s policies before purchasing so you are aware of any potential fees.'
            : 'Users are solely responsible for conducting their own due diligence before engaging in any transaction. All transactions are conducted at your own risk. Any disputes arising from transactions conducted on the platform are to be resolved directly between the buyer and seller.'}
        </div>
      )}

      {/* Download Mockups */}
      {/* {publicKey?.toBase58() === userDetail?.wallet_id && productDetail.fulfillment_type === 'foster' && (
        <div className="w-full lg:flex hidden justify-end mt-[35px]">
          <div className={styles.mockups} onClick={() => downloadFiles()}>
            <DownloadIcon />
            <div>Download Mockups</div>
          </div>
        </div>
      )} */}
      <div className="block mb-[100px]" />
    </div>
  )
}

export default MerchOrderDetail
